import styled, { css } from "styled-components";

export const NoPrintContainerStyles = css`
    @media print {
        display: none;
    }
`;

export const NoPrintContainer = styled.div`
    ${NoPrintContainerStyles};
`;
